import * as React from "react";
import * as d3 from "d3";

import Chart from "./components/Chart";

import "./App.css";

const logo = require("./logo.svg");

class App extends React.Component<null, null> {


	componentWillMount(): void {
		// console.log(data);
		// console.log(d3.tsvParse(data));

		// https://bl.ocks.org/mbostock/3884955
		d3.tsv("data.tsv", function(error, data) {

			if (error) throw error;

			console.log(data);

			/*
			var cities = data.columns.slice(1).map(function (id) {
				return {
					id: id,
					values: data.map(function (d) {
						return {date: d.date, temperature: d[id]};
					})
				};
			});
			*/
		});
	}

	render() {
		return (
			<div className="App">
				<div className="App-header">
					<img src={logo} className="App-logo" alt="logo"/>
					<h2>D3.js React-Motion Example</h2>
				</div>
				<Chart />
			</div>
		);
	}
}

export default App;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/App.tsx